module.exports = __webpack_public_path__ + "static/media/0002.ccc37a0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/0002.mp3
// module id = dkBL
// module chunks = 0